// This icon file is generated automatically.
var PFilterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.75 1.4H1.25a.5.5 0 00-.43.76l3.63 6.17v3.76c0 .28.22.5.5.5h4.1a.5.5 0 00.5-.5V8.33l3.63-6.17a.5.5 0 00-.43-.75zM8.43 11.48H5.57V9.03h2.86v2.44zm.15-3.7l-.15.26H5.57l-.15-.26-3.1-5.24h9.36l-3.1 5.24z", "fill-rule": "nonzero" } }] }, "name": "p-filter", "theme": "outlined" };
export default PFilterOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFilterOutlined.js
// module id = 3410
// module chunks = 0